import { Chip } from '@/components/DesignSystem';
import { Color } from '@/themes/MUITheme/palette';
import { getPromotionStatus, PromotionStatus } from '@/utilities/api/PromotionUtilities';
import { ApiPromotion } from '@api/interfaces';
import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PromotionStatusChipProps {
  promotion: Pick<ApiPromotion, 'endDate' | 'startDate'>,
}

const statusColors: { [key: string]: Color | undefined } = {
  [PromotionStatus.FUTURE]: 'info',
  [PromotionStatus.RUNNING]: 'success',
  [PromotionStatus.EXPIRED]: undefined,
};

export const PromotionStatusChip = ({
  promotion,
}: PromotionStatusChipProps) => {
  const { t } = useTranslation();
  const status = getPromotionStatus(promotion);
  const statusKey = status.toLowerCase();

  return (
    <Stack direction="row" gap="8px">
      <Chip
        color={statusColors[status]}
        label={t($ => $.promotions.status[statusKey as keyof typeof $.promotions.status])}
        rounded
        sx={{ fontWeight: 500, height: 20 }}
        testID={`promotion-status-${status}`}
      />
    </Stack>
  );
};
